import { defineStore } from 'pinia'
import axios from 'crypto-fetch/axios'

export const useCommonMyBetsStore = defineStore('commonMyBets', {
  state: () => ({
    myBetsCount: 0
  }),
  actions: {
    setMyBetsCount(count = 0) {
      this.myBetsCount = count
    },
    async getMyBetsCount() {
      try {
        const data = await axios.get('/real-sports-game/frontend/order/my-bets/count?type=0')
        this.myBetsCount = data
      } catch (error) {
        this.myBetsCount = 0
        console.error(error)
      }
    }
  }
})
